import { z } from "zod";
import { LOCALE_VALUES } from "../enum.js";

export const requestOtpSchema = z.object({
	email: z.email({ message: "Email is required" }).transform((e) => e.toLowerCase()),
	locale: z.enum(LOCALE_VALUES).optional(),
});

export type RequestOtpPayload = z.infer<typeof requestOtpSchema>;
